export const SET_SELECTED_IMAGES = "SET_SELECTED_IMAGES";
